module.exports = __webpack_public_path__ + "static/media/seat_red.5b53f444.svg";